<template>
  <div>
    <el-form :inline="true" :model="selectOption" class="demo-form-inline">
      <el-form-item label="id">
        <el-input v-model="selectOption.id" placeholder="请输入id"></el-input>
      </el-form-item>
      <el-form-item label="标题">
        <el-input
          v-model="selectOption.title"
          placeholder="请输入标题"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData.list" border style="width: 100%">
      <el-table-column prop="id" label="id" width="180"> </el-table-column>
      <el-table-column prop="title" label="标题" width="180"> </el-table-column>
      <el-table-column prop="body" label="描述"> </el-table-column>
       <el-table-column
      label="操作"
      width="100">
      <template #default="scope">
        <el-button @click="goRouter(scope.row.id)" type="text" size="small">查看</el-button>
        <el-button v-if="btnAuthority.indexOf(8)!==-1" @click="delGoodsFun(scope.row.id)" type="text" size="small">删除</el-button>
      </template>
    </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="tableData.page"
      layout="total, prev, pager, next, jumper"
      :total="tableData.total"
    >
    </el-pagination>
  </div>
  <el-dialog title="商品详情" destroy-on-close v-model="isShow">
  <good-details :id="goodId"/>
</el-dialog>
</template>
<script>
import { onMounted, reactive,ref } from "vue";
import {useRouter} from 'vue-router'
// import axios from 'axios'
// import $http from '../http/index'
import {getGoodList,delGood} from '../http/api'
import { ElMessage } from 'element-plus'
import GoodDetails from './goodDetails.vue';

import roleIdData from '../sateJs/roleId.js'

export default {
  components:{
    GoodDetails,
  },
  setup() {
      const router=useRouter()
      console.log(router)
    let selectOption = reactive({
      id: "",
      title: "",
    });
    let isShow = ref(false)
    let goodId = ref('')
    

    let tableData = reactive({
      list: [],
      page: 1,
      pages: 10,
      total:0,
    });
    let list = [];
    const onSubmit = () => {};
    const handleCurrentChange = (page)=>{
        tableData.page = page;
        tableData.list = list[page-1]
    }
    //页面初步渲染完毕
    onMounted(()=>{
       getGoodList().then(res=>{
            // console.log(res)
            // if(res.data.code===200){
                // list =  res.data;
                //获取总条数
                tableData.total = res.length;
                // 遍历数据，拆分为[[],[],[]]
                for (let index = 0; index <  res.length; index++) {
                    list.push(res.slice(index,index+10));
                    //??????????????
                    index+=9;
                }
                tableData.list = list[0]
                tableData.pages = list.length;
            // }
        })
    })

    const goRouter = (id)=>{
        //    /goosList/1/Tina  /goosList
        //总体的划分为2中 ，一种是params，/goosList/1/Tina     另一种是query ?id=1&title=Tina
        //params   1.使用push方法携带参数 ，刷新参数会丢失  ，参数不需要提前定制,跳转路径对象需要使用name匹配
        //         2.在路由规则里制定好参数，  参数的顺序不能改变  ，
        goodId.value=id;
        isShow.value=true
        // router.push({
        //     name:'GoodDetails',
        //     query:{
        //         id,
        //     }
        // })
    }

    const delGoodsFun=(id)=>{
        delGood({id}).then(res=>{
            console.log(res)
           tableData.list.splice(tableData.list.findIndex(e=>e.id==id),1)
            ElMessage.success({
            message: '删除成功',
            type: 'success'
          });
        })
    }
    return {
      selectOption,
      onSubmit,
      tableData,
      handleCurrentChange,
      goRouter,
      delGoodsFun,
      isShow,
      goodId,
      btnAuthority:roleIdData.btnAuthority
    };
  },
};
</script>